import {
  OPERATORS_BY_KIND,
  optionSetOperator,
  supportsOptionSet,
  type FilterOperator,
  type OptionSetOperator,
} from "@shared/records/filter-clause";
import type { RecordFieldDef } from "../types";

const NULL_OPERATORS: FilterOperator[] = ["is_known", "is_unknown"];

export function operatorsFor(field: RecordFieldDef): FilterOperator[] {
  const operators = field.operators ?? OPERATORS_BY_KIND[field.kind];
  if (field.nullable) return operators;
  return operators.filter((operator) => !NULL_OPERATORS.includes(operator));
}

export function hasOptionValues(field: RecordFieldDef): boolean {
  return field.options !== undefined || field.onOptionSearch !== undefined;
}

export function optionSetOperatorFor(
  field: RecordFieldDef,
  operator: FilterOperator,
): OptionSetOperator | undefined {
  const setOperator = optionSetOperator(operator);
  if (!setOperator || !hasOptionValues(field)) return undefined;
  return supportsOptionSet(operatorsFor(field), setOperator)
    ? setOperator
    : undefined;
}

export function pickerOperatorsFor(field: RecordFieldDef): FilterOperator[] {
  return operatorsFor(field).filter((operator) => {
    const setOperator = optionSetOperatorFor(field, operator);
    return setOperator === undefined || setOperator === operator;
  });
}
